// Initialize Sentry FIRST
import { initSentryClient } from '../sentry-client';
initSentryClient();

import { createRoot } from 'react-dom/client';
import { PostHogProvider } from 'posthog-js/react';
import { Sentry } from '../sentry-client';
import { App } from './App';

const container = document.getElementById('root')!;
const root = (container as any)._reactRoot || createRoot(container);
if (!(container as any)._reactRoot) {
  (container as any)._reactRoot = root;
}

const ErrorFallback = () => (
  <div style={{
    padding: '2rem',
    textAlign: 'center',
    color: '#e4e7eb',
    backgroundColor: '#0d1117',
    minHeight: '100vh'
  }}>
    <h1>Something went wrong</h1>
    <p>We've been notified and are looking into it.</p>
    <button
      onClick={() => window.location.reload()}
      style={{
        marginTop: '1rem',
        padding: '0.5rem 1rem',
        cursor: 'pointer'
      }}
    >
      Reload page
    </button>
  </div>
);

root.render(
  <PostHogProvider
    apiKey="phc_5hz4p72DnZ3NoU6N4vrluGeqcxWyq3hW5o07rmUQGoZ"
    options={{
      api_host: 'https://us.i.posthog.com',
      person_profiles: 'identified_only',
    }}
  >
    <Sentry.ErrorBoundary
      fallback={<ErrorFallback />}
      showDialog={false}
    >
      <App />
    </Sentry.ErrorBoundary>
  </PostHogProvider>
);
